<template>
  <div class="flex items-center justify-between">
    <label
      class="flex items-center gap-[9px] cursor-pointer"
      @click="handleEndsType(value)"
    >
      <input
        type="radio"
        name="radio"
        class="min-w-[20px] w-[20px] min-h-[20px] h-[20px]"
        :checked="model == value"
      />
      <span
        class="text-[16px] text-charcoal leading-[20px] tracking-[0.25px]"
        :class="{ 'font-bold': model == value }"
        >{{ label }}</span
      >
    </label>
    <slot></slot>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean],
    default: () => '',
  },
  label: {
    type: String,
    default: '',
  },
  checked: {
    type: Boolean,
    default: false,
  },
  value: {
    type: [String, Number],
    default: '',
  },
});

const model = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    model.value = newVal;
  }
);

const handleEndsType = (value) => {
  model.value = value;
  emit('update:modelValue', model.value);
};
</script>
